import { DEFAULT_COUNTRY } from "@/utils/consts";
import helpers from "@/utils/helpers";
import { encryptString } from '@/utils/Utils'
import { DateTime } from "luxon";

const adaptExternalCode = (externalCode) =>
  externalCode && externalCode !== "null" ? Number(externalCode) : undefined;

const getFullAddress = ({ userData, domicilioData }) => {
  const { tipoVia, nombreVia, numeroVia } = domicilioData;

  let fullAddress = [tipoVia?.label, nombreVia, numeroVia]
    .filter(Boolean)
    .map((part) => part.toUpperCase())
    .join(" ");

  return fullAddress.length !== 0
    ? fullAddress
    : userData?.direccion?.direccion;
};

const getAddressParts = (data) => {
  const { userData, domicilioData } = data;
  const direccion = userData?.direccion ?? {};
  const {
    selectedDepartamento,
    selectedProvincia,
    selectedDistrito,
  } = domicilioData;

  const country = {
    id: Number(direccion?.idepais ?? DEFAULT_COUNTRY.id),
    name: direccion?.dscpais ?? DEFAULT_COUNTRY.name,
  };

  const department = {
    id: Number(selectedDepartamento?.ideDepartamento ?? direccion?.idedpto),
    name: selectedDepartamento?.descripcionDepartamento ?? direccion?.dscdpto,
  };

  const province = {
    id: Number(selectedProvincia?.ideProvincia ?? direccion?.ideprov),
    name: selectedProvincia?.descripcionProvincia ?? direccion?.dscprov,
  };

  const district = {
    id: Number(selectedDistrito?.ideDistrito ?? direccion?.idedist),
    name: selectedDistrito?.descripcionDistrito ?? direccion?.dscdist,
    ubigeo: selectedDistrito?.ubigeo ?? direccion?.ubigeo,
  };

  const fullAddress = getFullAddress(data);

  return {
    country,
    department,
    province,
    district,
    fullAddress,
  };
};

const parseDataBeneficiaries = (beneficiaries) => {
  const beneficiariesData = beneficiaries.map((beneficiary) => {
    const {
      names,
      lastName,
      surName,
      documentNumber,
      documentType,
      birthdate,
      gender,
      percentage,
      relationship,
      numId
    } = beneficiary;

    return {
      numId,
      tipoBeneficiario: "BENEFICIARIO",
      parentesco: Number(relationship),
      apellidoPaterno: encryptString(lastName?.toUpperCase()),
      apellidoMaterno: encryptString(surName?.toUpperCase()),
      nombres: encryptString(names?.toUpperCase()),
      tipoDocumento: Number(documentType),
      fechaNacimiento: encryptString(
				DateTime.fromFormat(birthdate, "dd/MM/yyyy").toFormat("yyyy-MM-dd")
			),
      sexo: helpers.convertToSafeString(gender),
      numeroDocumento: helpers.convertToSafeString(documentNumber),
      proteccionDatosPersonales: "S",
      porcentajeParticipacion: Number(percentage),
      envioComunicacionesComerciales: "S",
    };
  });

  return beneficiariesData;
};

export const adaptEndorseQuoteVEData = (data) => {
  const { userData, domicilioData, plans, beneficiaries } = data;
  const {
    country,
    department,
    province,
    district,
    fullAddress,
  } = getAddressParts(data);
  const assuredFinancialEntity = plans.planSelected.assuredFinancialEntity;
  const {
    numId: bankId,
    idTercero: bankNumId,
    razonSocial: bankBusinessName,
  } = assuredFinancialEntity;

  const tercero = {
    numId: adaptExternalCode(userData?.tercero),
    apeMaterno: encryptString(userData?.apellidoMaterno),
    apePaterno: encryptString(userData?.apellidoPaterno),
    nombre: encryptString(userData?.nombres),
    tipoDocumento: Number(userData?.tipoDocumento ?? userData?.typeDoc),
    fecNacimiento: encryptString(userData?.fechaNacimiento ?? userData?.fecNac),
    numeroDocumento: userData?.numeroDocumento ?? userData?.documento,
    sexo: userData?.sexo,
    correo: encryptString(userData?.correo ?? userData?.email),
    telefono: userData?.telefono,
    ubigeo: district.ubigeo,
    tipoVia: domicilioData?.tipoVia.id,
    nombreVia: helpers.convertToSafeString(domicilioData?.nombreVia),
    numeroVia: domicilioData?.numeroVia,
    codigoPais: country.id,
    pais: country.name,
    idDepartamento: department.id,
    nombDepartamento: department.name,
    idProvincia: province.id,
    ideDistrito: district.id,
    dscDistrito: district.name,
    direccion: fullAddress,
    envioComunicacionesComerciales: "S",
    proteccionDatosPersonales: "S",
    envioPolizaElectronica: "S",
    porcentajeParticipacion: 100,
    ideRol: 23,
  };
  const beneficiarios = [
    {
      tipoBeneficiario: "ENDOSATARIO",
      porcentajeParticipacion: 100,
      comentario: `${bankBusinessName} .- Hasta la suma que estuviere adeudando a la fecha de su fallecimiento. En caso que hubiere algún remanente de la suma asegurada, será entregado a: Los Beneficiarios.`,
      numId: bankId,
      idTercero: bankNumId,
    },
    ...parseDataBeneficiaries(beneficiaries),
  ];

  return {
    idCotizacion: plans.data.idCotizacion,
    tercero,
    beneficiarios,
  };
};
